export default "__VITE_ASSET__CBkEkAGi__"